<template>
  <div>
    <div class="row">
      <div class="col-12 h5">Datum und Startzeit</div>
      <div class="col-12 col-md-6">
        <reservation-calendar
            @dayclick="dateSelected($event)"/>
        <div class="form-row">
          <label for="startDateInput">Datum</label>
          <input id="startDateInput" type="date" class="form-control" v-model="startDateForForm" disabled/>
        </div>
        <div class="form-row">
          <label for="startHourInput">Start-Stunde</label>
          <input id="startHourInput" type="number" class="form-control" v-model.number="startHour"/>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <reservation-day-calendar :date="startDate" :highlight-start-hour="startHour"
                                  :highlight-stop-hour="startHour + reservation.duration"/>
      </div>
    </div>
    <div class="form-row">
      <label for="durationInput">Dauer in Stunden</label>
      <input id="durationInput" type="number" class="form-control" v-model.number="reservation.duration"/>
    </div>
    <div class="form-row">
      <label for="attendeesInput">Teilnehmer</label>
      <input id="attendeesInput" type="number" class="form-control" v-model.number="reservation.attendees"/>
    </div>
    <div class="form-group mt-2">
      <div class="form-check">
        <input id="confirmedInput" type="checkbox" class="form-check-input" v-model="confirmed"/>
        <label for="confirmedInput" class="form-check-label">bestätigt</label>
      </div>
    </div>
    <div class="form-group">
      <label for="productSelector">Produkt</label>
      <div id="productSelector">
        <product-selector v-model="reservation.product.id"/>
      </div>
    </div>
    <div>
      Kunde
      <span v-if="customerDefined">: {{ reservation.customer.firstName }} {{ reservation.customer.lastName }}
        <span class="text-danger font-weight-bold link" @click="reservation.customer = {}">&times;</span>
      </span>
    </div>
    <div class="row mt-2">
      <div class="col-8">
        <customer-selector @select="setCustomerFromSearchResult($event)"/>
      </div>
      <div class="col-4">

      </div>
      <div class="col-12" v-if="!customerDefined">
        <div class="card">
          <div class="card-header">
            Neuen Kunden anlegen
          </div>
          <div class="card-body">
            <customer-editor v-model="reservation.customer"/>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right mt-3">
      <button class="btn btn-success" :disabled="!customerDefined" @click="placeReservationRequest">Reservierung
        speichern
      </button>
    </div>
  </div>
</template>

<script>

import ProductSelector from "@/components/ProductSelector";
import CustomerEditor from "@/components/customer/CustomerEditor";
import CustomerSelector from "@/components/customer/CustomerSelector";
import {DateTime} from "luxon";
import ReservationCalendar from "../erp/ReservationCalendar.vue";
import ReservationDayCalendar from "../erp/ReservationDayCalendar.vue";

export default {
  components: {ReservationDayCalendar, ProductSelector, CustomerEditor, CustomerSelector, ReservationCalendar},
  props: {
    value: Object
  },
  data() {
    return {
      reservation: {
        customer: null,
        product: {}
      },
      send: false,
      confirmed: false,
      startDate: DateTime.now(),
      startHour: 10
    }
  },
  computed: {
    customerDefined() {
      return (this.reservation.customer
          && this.reservation.customer.email
          && this.reservation.customer.firstName
          && this.reservation.customer.phone) ? true : false
    },
    startDateForForm() {
      return this.startDate.toFormat("yyyy-MM-dd");
    }
  },
  methods: {
    dateSelected(dayObject) {
      this.startDate = DateTime.local(dayObject.year, dayObject.month, dayObject.day, 0)
    },
    placeReservationRequest() {
      const res = {...this.reservation}
      res.startTime = DateTime.local(this.startDate.year, this.startDate.month, this.startDate.day, this.startHour).toJSDate()
      console.log(DateTime.fromJSDate(res.startTime).toFormat("yyyy-MM-dd HH:00:00"))
      res.startTimeStr = DateTime.fromJSDate(res.startTime).toFormat("yyyy-MM-dd HH:00:00")
      this.$api.post('/reservations', res, {
        params: {
          send: false
        }
      }).then((response) => {
        this.$emit('input', response.data)
      }).catch(err => this.handleError(err))
    },
    async setCustomerFromSearchResult(searchResult) {
      this.reservation.customer = await this.$api.get(`/customers/${searchResult.id}`).then(res => res.data)
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal)
          this.reservation = {...newVal}
      },
      immediate: true
    },
    confirmed: {
      handler(newVal) {
        this.reservation.state = newVal ? 'confirmed' : 'requested'
      },
      immediate: true
    }
  }
}
</script>
